import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static targets = [
    "defaultIndicatorField",
    "select",
    "selectAllDefaultIndicators",
  ];

  initialize() {
    this.selects = [];
  }

  selectTargetConnected(target) {
    const select = new SlimSelect({
      select: target,
      settings: {
        showSearch: false,
      },
    });
    this.selects.push(select);
  }

  /**
   * Sets the initial state of the select all checkbox from the current
   * selection.
   */
  selectAllDefaultIndicatorsTargetConnected(target) {
    // eslint-disable-next-line no-param-reassign
    target.checked = this.defaultIndicatorFieldTargets.every(
      (cb) => cb.checked,
    );
  }

  /**
   * Toggle all of the default indicator checkboxes on or off depending on the
   * value of the select all checkbox that triggered the event.
   */
  toggleSelectAllDefaultIndicators({ target: { checked } }) {
    this.defaultIndicatorFieldTargets.forEach((cb) => {
      // eslint-disable-next-line no-param-reassign
      cb.checked = checked;
    });
  }

  disconnect() {
    this.selects.forEach((select) => select.destroy());
    this.selects = [];
  }
}
